import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff443da6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "d-flex justify-content-center pb-10" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "text-start mb-6" }
const _hoisted_5 = {
  class: "fs-4 text-gray-600 fw-semibold",
  style: {"width":"880px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Declaramos para os devidos fins que o certificado número ")
const _hoisted_7 = { class: "fw-bold text-gray-700" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" é autêntico e foi expedido pela CROWSEC para ")
const _hoisted_11 = { class: "fw-bold text-gray-700" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" no dia ")
const _hoisted_13 = { class: "fw-bold text-gray-700" }
const _hoisted_14 = { class: "certificate-container" }
const _hoisted_15 = { class: "code-security" }
const _hoisted_16 = { class: "main-content position-relative" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "title" }, "CROWSEC", -1))
const _hoisted_18 = { id: "cert-name" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "certification-text my-5" }, "A CROWSEC, certifica o aluno", -1))
const _hoisted_20 = { class: "student-name my-3" }
const _hoisted_21 = { class: "cert-description" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-row align-items-center justify-content-between mx-20\" data-v-ff443da6><div class=\"sign-section\" data-v-ff443da6><img src=\"/media/certificate/as-kadu.png\" alt=\"\" data-v-ff443da6><div class=\"signature\" data-v-ff443da6>CARLOS EDUARDO VIEIRA</div><div class=\"line-sign\" data-v-ff443da6></div><div data-v-ff443da6>Avaliador técnico</div></div><div class=\"logo-section\" data-v-ff443da6><img src=\"/media/certificate/logo1.png\" alt=\"\" data-v-ff443da6></div><div class=\"sign-section\" data-v-ff443da6><img src=\"/media/certificate/as-lu.png\" alt=\"\" data-v-ff443da6><div class=\"signature\" data-v-ff443da6>LUCIANE CICHON GOES</div><div class=\"line-sign\" data-v-ff443da6></div><div data-v-ff443da6>CEO</div></div></div>", 1)
const _hoisted_23 = { class: "validation-text" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Valide a certificação em ")
const _hoisted_25 = ["href"]


import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  props: {
  certificate: {}
},
  setup(__props) {

const props = __props



const formatDate = (date: string) =>{
  return moment(date).format('DD/MM/YY');
}

const slugToName = (slug: string) =>{
  return slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.certificate?.validation_id), 1),
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(__props.certificate?.user_name), 1),
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(formatDate(__props.certificate?.issue_date)) + ".", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
            class: "side-bar cursor-pointer"
          }, [
            _createElementVNode("div", _hoisted_15, " Código de segurança: " + _toDisplayString(__props.certificate?.validation_id) + "/Emissão realizada em " + _toDisplayString(formatDate(__props.certificate?.issue_date)), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(slugToName(__props.certificate?.certificate_name)), 1),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(__props.certificate?.user_name), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(__props.certificate?.certificate_description), 1),
            _hoisted_22,
            _createElementVNode("p", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  class: "text-white",
                  href: `${_ctx.appUrl}/certificate/validate`,
                  target: "_blank"
                }, " https://app.hackingclub.com/certificate/validate ", 8, _hoisted_25)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})